import { Alert, AlertFromJSON, defaultAlert, exists } from '@/api'

export interface ReturnCheckAlert extends Alert {
  userId: string
  userMemoId: number
  userMemoRevision: number
}

export const defaultReturnCheckAlert = (): ReturnCheckAlert => ({
  ...defaultAlert(),
  userId: '',
  userMemoId: 0,
  userMemoRevision: 0
})

export function ReturnCheckAlertFromJSON(json: any): ReturnCheckAlert {
  const alert: Alert = AlertFromJSON(json)

  return {
    ...alert,
    userId: exists(json, 'user_id') ? json.user_id : '',
    userMemoId: exists(json, 'user_memo_id') ? json.user_memo_id : 0,
    userMemoRevision: exists(json, 'user_memo_revision')
      ? json.user_memo_revision
      : 0
  }
}
